import React, { useState, useEffect } from 'react'
import './InterviewerDashboard.css'
import { Header } from '../../components/Header/Header'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { Link, useNavigate } from 'react-router-dom'
import moment from 'moment'
import DataTable from 'react-data-table-component'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const InterviewerDashboard = () => {
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  // to keep nav value highlighted when on same route
  useEffect(() => {
    var nav_item = document.getElementById('homenav')
    nav_item.classList.add('navlinkactive')
  }, [])

  // fetching email and username from localstorage

  const userName = localStorage.getItem('user')
  const token = localStorage.getItem('token')
  const id = localStorage.getItem('id')

  // get all interviews of loggedin inerviewer
  const [profiles, setProfiles] = useState([])

  const getProfiles = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'dashboard/fetchInterviewerCandidates',
        {
          id: id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        setProfiles(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  useEffect(() => {
    getProfiles()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // columns to display data in table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Name',
      cell: (row) => {
        return (
          <Tippy content={row.candidate_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
            >
              {' '}
              {row.candidate_name}
            </p>
          </Tippy>
        )
      },
      sortable: true,
    },

    {
      name: 'Designation',
      cell: (row) => {
        return (
          <Tippy content={row.designation} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
            >
              {' '}
              {row.designation}
            </p>
          </Tippy>
        )
      },
      sortable: true,
    },

    {
      name: 'Interview Round',
      selector: (row) => row.interview_round,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Interview Date',
      selector: (row) => moment(row.interview_date).format('DD-MM-YYYY'),
      sortable: true,
      width: '150px',
    },
    {
      name: 'Interview Time',
      selector: (row) => row.interview_time,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Actions',
      cell: (row) => {
        return (
          <Link to={'/viewDetails/' + row.uuid} className="link">
            <button className="btn btn-outline-primary btn-sm">
              View Details
            </button>
          </Link>
        )
      },
      sortable: true,
      width: '150px',
    },
  ]

  return (
    <>
      <Header />
      <div className="container interviewerDashboard mt-5">
        <h5 className="mt-3 mb-4 mx-3">Welcome, {userName}!</h5>
        <DataTable
          title="Up Coming Interviews"
          columns={columns}
          data={profiles}
          pagination
          highlightOnHover
        />
      </div>
    </>
  )
}
